import React from 'react';
import { useLanguage } from './LanguageContext';
import { motion } from 'framer-motion';
import { HeartHandshakeIcon, ExternalLinkIcon, HeartIcon } from 'lucide-react';
export function FGMHopeClinic() {
  const {
    t
  } = useLanguage();
  return <section id="clinic" className="py-20 bg-teal-50" data-id="element-111">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-sm text-center border border-teal-100/50" data-id="element-113">
          <div className="w-16 h-16 bg-teal-50 text-teal-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-114">
            <HeartHandshakeIcon size={32} data-id="element-115" />
          </div>

          <h2 className="text-3xl font-serif font-medium text-teal-900 mb-6" data-id="element-116">
            {t.fgm.title}
          </h2>

          <p className="text-lg text-slate-600 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-117">
            {t.fgm.text}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-118">
            <a href="https://www.fgmhopeclinic.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center space-x-2 bg-teal-50 hover:bg-teal-100 text-teal-700 px-8 py-3 rounded-full font-medium transition-colors" data-id="element-119">
              <ExternalLinkIcon size={18} data-id="element-120" />
              <span data-id="element-121">Visit Website</span>
            </a>
            <a href="https://www.gofundme.com/f/celebrating-20-yearswounds-to-warriorgive-hope-to-20-women" target="_blank" rel="noopener noreferrer" className="inline-flex items-center space-x-2 bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-full font-medium transition-colors shadow-sm" data-id="element-122">
              <HeartIcon size={18} data-id="element-123" />
              <span data-id="element-124">Support on GoFundMe</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}